module.exports = __webpack_public_path__ + "static/construction-9f78f32f564b53e4b8b13283e8d2ce21.jpg";